"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isCtaStoryContentContainerProperty = exports.ctaStoryContentContainerPropertyDefinition = void 0;
exports.ctaStoryContentContainerPropertyDefinition = {
    view: { label: 'CTA' },
    constraints: [
        {
            name: 'oneOfProperties',
            argument: ['cta-url', 'cta-asset'],
        },
    ],
    type: 'one-of-container',
    multiple: false,
    name: 'cta-story-content-container',
};
const isCtaStoryContentContainerProperty = (prop) => {
    return prop.name === exports.ctaStoryContentContainerPropertyDefinition.name;
};
exports.isCtaStoryContentContainerProperty = isCtaStoryContentContainerProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY3RhLXN0b3J5LWNvbnRlbnQtY29udGFpbmVyLnByb3BlcnR5LmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL3Byb3BlcnRpZXMvY3RhLXN0b3J5LWNvbnRlbnQtY29udGFpbmVyLnByb3BlcnR5LnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsMENBQTBDLEdBQUc7SUFDeEQsSUFBSSxFQUFFLEVBQUUsS0FBSyxFQUFFLEtBQUssRUFBRTtJQUN0QixXQUFXLEVBQUU7UUFDWDtZQUNFLElBQUksRUFBRSxpQkFBaUI7WUFDdkIsUUFBUSxFQUFFLENBQUMsU0FBUyxFQUFFLFdBQVcsQ0FBQztTQUNuQztLQUNGO0lBQ0QsSUFBSSxFQUFFLGtCQUFrQjtJQUN4QixRQUFRLEVBQUUsS0FBSztJQUNmLElBQUksRUFBRSw2QkFBNkI7Q0FDSixDQUFBO0FBSTFCLE1BQU0sa0NBQWtDLEdBQUcsQ0FBQyxJQUFrQixFQUE0QyxFQUFFO0lBQ2pILE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxrREFBMEMsQ0FBQyxJQUFJLENBQUE7QUFDdEUsQ0FBQyxDQUFBO0FBRlksUUFBQSxrQ0FBa0Msc0NBRTlDIn0=